import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { DatePickerField, Input } from "../../../../_metronic/_partials/controls";
import { SelectObjectsField } from "../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField";
import { SelectGender } from '../../customComponents/SelectGender';

export { filterFields } from "../../customComponents/filterFields";

export const initObject = {
    id: undefined,
    dormId: null,
    blockId: null,
    roomId: null,
    roleId: 0,
    groupId: 0,
    subGroupId: 0,
    placeId: null,
    collageId: null,
    fieldId: null,
    gradeId: null,
    workUnitId: null,
    provinceId: null,
    provinceTitle: "",
    townId: null,
    placeTitle: "",
    townTitle: "",
    username: "",
    idNumber: "",
    firstName: "",
    lastName: "",
    nationalCode: null,
    gender: "Male",
    semat: "",
    email: "",
    mobile: "",
    phone: "",
    barcodeNumber: null,
    expirationDate: "",
    deliveryDate: "",
    credit: 0,
    lastLoginDate: "",
    lastLoginIp: "",
    reasonDeactivated: "",
    isPayOff: true,
    lostCard: true,
    replicaCard1: true,
    replicaCard2: true,
    replicaCard3: true,
    isLogin: true,
    isActive: true,
    isDeleted: false,
    needChangePassword: true,
};


export const columns = [
    {
        dataField: "username",
        text: columnFormatters.translateByMessageId(
            "MODULES.BASEINFO.USERS.USERNAME"
        ),
        sort: true,
        sortCaret: sortCaret,
    },
    {
        dataField: "idNumber",
        text: columnFormatters.translateByMessageId(
            "MODULES.BASEINFO.USERS.IDNUMBER"
        ),
        sort: true,
        sortCaret: sortCaret,
    },
    {
        dataField: "firstName",
        text: columnFormatters.translateByMessageId("MODULES.BASEINFO.USERS.FIRSTNAME"),
        sort: true,
        sortCaret: sortCaret,
    },
    {
        dataField: "lastName",
        text: columnFormatters.translateByMessageId("MODULES.BASEINFO.USERS.LASTNAME"),
        sort: true,
        sortCaret: sortCaret,
    },
    {
        dataField: "placeTitle",
        text: columnFormatters.translateByMessageId("MODULES.BASEINFO.PLACE.TITLE"),
        sort: true,
        sortCaret: sortCaret,
    },
    {
        dataField: "semat",
        text: "سمت",
        sort: true,
        sortCaret: sortCaret,
    },
    {
        dataField: "provinceTitle",
        text: "استان",
        sort: true,
        sortCaret: sortCaret,
    },
    {
        dataField: "townTitle",
        text: "شهر",
        sort: true,
        sortCaret: sortCaret,
    },
    {
        dataField: "isDeleted",
        text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
        sort: true,
        sortCaret: sortCaret,
        formatter: columnFormatters.StatusColumnFormatter,
    },
    // {
    //     dataField: "action",
    //     text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
    //     formatter: columnFormatters.ActionsColumnFormatter,
    //     formatExtraData: {
    //         // openEditObjectPage: objectsUIProps.openEditObjectPage,
    //         // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
    //     },
    //     classes: "text-right pr-0",
    //     headerClasses: "text-right pr-3",
    //     style: {
    //         minWidth: "100px",
    //     },
    // },
];

export const formFields = [
    {
        name: "username",
        type: "text",
        component: Input,
        label: "MODULES.BASEINFO.USERS.USERNAME",
        placeholder: "MODULES.BASEINFO.USERS.USERNAME_PH",
        rowIdx: 1,
        class: "col-lg-4",
    },
    {
        name: "idNumber",
        type: "text",
        component: Input,
        placeholder: "MODULES.BASEINFO.USERS.IDNUMBER_PH",
        label: "MODULES.BASEINFO.USERS.IDNUMBER",
        rowIdx: 2,
        class: "col-lg-4",
    },
    {
        name: "firstName",
        type: "text",
        component: Input,
        placeholder: "MODULES.BASEINFO.USERS.FIRSTNAME_PH",
        label: "MODULES.BASEINFO.USERS.FIRSTNAME",
        rowIdx: 3,
        class: "col-lg-4",
    },
    {
        name: "lastName",
        type: "text",
        component: Input,
        placeholder: "MODULES.BASEINFO.USERS.LASTNAME_PH",
        label: "MODULES.BASEINFO.USERS.LASTNAME",
        rowIdx: 4,
        class: "col-lg-4",
    },
    {
        name: "gender",
        type: "option",
        component: SelectGender,
        placeholder: "MODULES.BASEINFO.USERS.GENDER_PH",
        label: "MODULES.BASEINFO.USERS.GENDER",
        rowIdx: 5,
        class: "col-lg-4",
    },
    // {
    //     name: "nationalCode",
    //     type: "number",
    //     component: Input,
    //     placeholder: "MODULES.BASEINFO.USERS.NATIONALCODE_PH",
    //     label: "MODULES.BASEINFO.USERS.NATIONALCODE",
    //     rowIdx: 6,
    //     class: "col-lg-4",
    // },
    {
        name: "email",
        type: "text",
        component: Input,
        placeholder: "MODULES.BASEINFO.USERS.EMAIL_PH",
        label: "MODULES.BASEINFO.USERS.EMAIL",
        rowIdx: 7,
        class: "col-lg-4",
    },
    {
        name: "mobile",
        type: "text",
        component: Input,
        placeholder: "MODULES.BASEINFO.USERS.MOBILE_PH",
        label: "MODULES.BASEINFO.USERS.MOBILE",
        rowIdx: 8,
        class: "col-lg-4",
    },
    {
        name: "phone",
        type: "text",
        component: Input,
        placeholder: "MODULES.BASEINFO.USERS.PHONE_PH",
        label: "MODULES.BASEINFO.USERS.PHONE",
        rowIdx: 9,
        class: "col-lg-4",
    },
    {
        name: "semat",
        type: "text",
        component: Input,
        placeholder: "MODULES.BASEINFO.USERS.SEMAT_PH",
        label: "MODULES.BASEINFO.USERS.SEMAT",
        rowIdx: 9,
        class: "col-lg-4",
    },
    // {
    //     name: "lastLoginIp",
    //     type: "text",
    //     component: Input,
    //     placeholder: "MODULES.BASEINFO.USERS.LASTLOGINIP_PH",
    //     label: "MODULES.BASEINFO.USERS.LASTLOGINIP",
    //     rowIdx: 9,
    //     class: "col-lg-4",
    // },
    // {
    //     name: "lastLoginDate",
    //     type: "text",
    //     component: DatePickerField,
    //     placeholder: "MODULES.BASEINFO.USERS.LASTLOGINDATE_PH",
    //     label: "MODULES.BASEINFO.USERS.LASTLOGINDATE",
    //     rowIdx: 10,
    //     class: "col-lg-4",
    // },
    // {
    //     name: "barcodeNumber",
    //     type: "text",
    //     component: Input,
    //     placeholder: "MODULES.BASEINFO.USERS.BARCODENUMBER_PH",
    //     label: "MODULES.BASEINFO.USERS.BARCODENUMBER",
    //     rowIdx: 11,
    //     class: "col-lg-4",
    // },
    // {
    //     name: "credit",
    //     type: "text",
    //     component: Input,
    //     placeholder: "MODULES.BASEINFO.USERS.CREDIT_PH",
    //     label: "MODULES.BASEINFO.USERS.CREDIT",
    //     rowIdx: 12,
    //     class: "col-lg-4",
    // },
    // {
    //     name: "reasonDeactivated",
    //     type: "text",
    //     component: Input,
    //     placeholder: "MODULES.BASEINFO.USERS.REASONDEACTIVATED_PH",
    //     label: "MODULES.BASEINFO.USERS.REASONDEACTIVATED",
    //     rowIdx: 13,
    //     class: "col-lg-4",
    // },
    {
        name: "deliveryDate",
        type: "text",
        component: DatePickerField,
        placeholder: "تاریخ شروع فعالیت",
        label: "تاریخ شروع فعالیت",
        rowIdx: 14,
        class: "col-lg-4",
    },
    {
        name: "expirationDate",
        type: "text",
        component: DatePickerField,
        placeholder: "MODULES.BASEINFO.USERS.EXPIRATIONDATE_PH",
        label: "MODULES.BASEINFO.USERS.EXPIRATIONDATE",
        rowIdx: 15,
        class: "col-lg-4",
    },

];

export const otherFields = [
    {
        name: "provinceId",
        type: "select",
        component: (props) =>
            <SelectObjectsField api="api/province"
                reduxState="provinces"
                sname="provinceId"
                label={""}
                {...props} />,
        placeholder: "MODULES.BASEINFO.COLLAGE.FORM_TITLE",
        label: "MODULES.BASEINFO.COLLAGE.FORM_TITLE",
        rowIdx: 17,
        class: "col-lg-4",
        relField: ["townId"],
        relValues: { townId: 0, townTitle: "" }
    },
    {
        name: "townId",
        type: "option",
        component: (props) =>
            <SelectObjectsField api="api/town"
                reduxState="towns"
                sname="townId"
                label={""}
                {...props} />,
        placeholder: "MODULES.BASEINFO.TOWN.TITLE",
        label: "MODULES.BASEINFO.TOWN.TITLE",
        rowIdx: 18,
        class: "col-lg-4",
        relField: [],
        relValues: {}
    },
    {
        name: "placeId",
        type: "option",
        component: (props) =>
            <SelectObjectsField api="api/place"
                reduxState="places"
                sname="placeId"
                label={""}
                {...props} />,
        placeholder: "MODULES.BASEINFO.PLACE.TITLE",
        label: "MODULES.BASEINFO.PLACE.TITLE",
        rowIdx: 19,
        class: "col-lg-4",
        relField: [],
        relValues: {}
    },
    {
        name: "groupId",
        type: "select",
        component: (props) =>
            <SelectObjectsField api="api/group"
                reduxState="groups"
                sname="groupId"
                label={""}
                {...props} />,
        placeholder: "MODULES.BASEINFO.Group.FORM_TITLE",
        label: "MODULES.BASEINFO.Group.FORM_TITLE",
        rowIdx: 20,
        class: "col-lg-4",
        relField: ["subGroupId"],
        relValues: { subGroupId: 0 },
    },
    {
        name: "subGroupId",
        type: "option",
        component: (props) =>
            <SelectObjectsField api="api/subGroup"
                reduxState="subGroups"
                sname="subGroupId"
                label={""}
                {...props} />,
        placeholder: "MODULES.BASEINFO.SubGroup.FORM_TITLE",
        label: "MODULES.BASEINFO.SubGroup.FORM_TITLE",
        rowIdx: 21,
        class: "col-lg-4",
        relField: [],
        relValues: {}
    },

    // {
    //     name: "collageId",
    //     type: "select",
    //     component: (props) =>
    //         <SelectObjectsField api="api/collage"
    //             reduxState="collages"
    //             sname="collageId"
    //             label={""}
    //             {...props} />,
    //     placeholder: "MODULES.BASEINFO.COLLAGE.FORM_TITLE",
    //     label: "MODULES.BASEINFO.COLLAGE.FORM_TITLE",
    //     rowIdx: 21,
    //     class: "col-lg-4",
    //     relField: ["fieldId"],
    //     relValues: { fieldId: 0 }
    // },
    // {
    //     name: "fieldId",
    //     type: "option",
    //     component: (props) =>
    //         <SelectObjectsField api="api/field"
    //             reduxState="fields"
    //             sname="fieldId"
    //             label={""}
    //             {...props} />,
    //     placeholder: "MODULES.BASEINFO.FIELD.FORM_TITLE",
    //     label: "MODULES.BASEINFO.FIELD.FORM_TITLE",
    //     rowIdx: 22,
    //     class: "col-lg-4",
    //     relField: [],
    //     relValues: {}
    // },

    {
        name: "roleId",
        type: "option",
        component: (props) =>
            <SelectObjectsField api="api/role"
                reduxState="roles"
                sname="roleId"
                label={""}
                {...props} />,
        placeholder: "MODULES.BASEINFO.ROLE.TITLE",
        label: "MODULES.BASEINFO.ROLE.TITLE",
        rowIdx: 23,
        class: "col-lg-4",
        relField: [],
        relValues: {}
    },

    // {
    //     name: "gradeId",
    //     type: "option",
    //     component: (props) =>
    //         <SelectObjectsField api="api/grade"
    //             reduxState="grades"
    //             sname="gradeId"
    //             label={""}
    //             {...props} />,
    //     placeholder: "MODULES.BASEINFO.GRADE.FORM_TITLE",
    //     label: "MODULES.BASEINFO.GRADE.FORM_TITLE",
    //     rowIdx: 23,
    //     class: "col-lg-4",
    //     relField: [],
    //     relValues: {}
    // },
];



export const filterInitialValues = {
    filter: {
        isDeleted: "",
        searchText: "",
        username: "",
        placeId: 0,
        groupId: 0,
        subGroupId: 0,
        provinceId: 0,
        townId: 0
    },
    sortOrder: "desc", // asc||desc
    sortField: "id",
    pageNumber: 1,
    pageSize: 10,

    whereClause: "",
    whereClauseParameters: [
    ],
    orderClause: "id desc ",
    skipCount: 0,
    takeCount: 10,
};

export const prepareFilter = (queryParams, values) => {
    const {
        isDeleted,
        searchText,
        username,
        placeId,
        groupId,
        subGroupId,
        provinceId,
        townId
    } = values;

    const newQueryParams = { ...queryParams };
    const filter = {};
    // Filter by isDeleted
    if (isDeleted !== undefined)
        filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;

    // Filter by all fields
    // filter.username = searchText;

    // if (searchText) {
    filter.searchText = searchText;
    // }

    filter.groupId = groupId !== "" ? +groupId : 0;
    filter.subGroupId = subGroupId !== "" ? +subGroupId : 0;
    filter.provinceId = provinceId !== "" ? +provinceId : 0;
    filter.subGroupId = subGroupId !== "" ? +subGroupId : 0;
    filter.townId = townId !== "" ? +townId : 0;
    filter.placeId = placeId !== "" ? +placeId : 0;

    newQueryParams.filter = filter;

    let whereClause = "";
    const whereClauseParameters = [];

    if (searchText != "" && searchText != null && searchText != undefined) {
        whereClause = whereClause + "username.contains(@0)";
        whereClauseParameters.push(searchText);

        whereClause = whereClause + " or idNumber.contains(@1)";
        whereClauseParameters.push(searchText);

        whereClause = whereClause + " or firstName.contains(@2)";
        whereClauseParameters.push(searchText);

        whereClause = whereClause + " or lastName.contains(@3)";
        whereClauseParameters.push(searchText);

        whereClause = whereClause + " or nationalCode.contains(@4)";
        whereClauseParameters.push(searchText);

        whereClause = whereClause + " or mobile.contains(@5)";
        whereClauseParameters.push(searchText);

        if (filter.isDeleted !== undefined) {
            whereClause = whereClause + " and isDeleted=@6";
            whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
        }
    }
    else if (filter.isDeleted !== undefined) {
        whereClause = whereClause + "isDeleted=@0";
        whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    }


    newQueryParams.whereClause = whereClause;
    newQueryParams.whereClauseParameters = whereClauseParameters;

    return newQueryParams;
};


// Validation schema
export const ObjectEditSchema = Yup.object().shape({
    username: Yup.string().required("پر کردن فیلد الزامی است"),
    idNumber: Yup.number().required("پر کردن فیلد الزامی است"),
    // nationalCode: Yup.number()
    //     .min(18, "18 is minimum")
    //     .max(18, "18 is maximum"),
    // dormId: Yup.number()
    //     .positive(columnFormatters.translateByMessageId("YUP.REQUIRED")),
    // blockId: Yup.number()
    //     .positive(columnFormatters.translateByMessageId("YUP.REQUIRED")),
    // roomId: Yup.number()
    //     .positive(columnFormatters.translateByMessageId("YUP.REQUIRED"))
});
